// extracted by mini-css-extract-plugin
export default {"imageContainer":"a71859bb1ba0","scrollContainer":"d0909b15fe50","highlight":"f83daa093d46"};